import { render, staticRenderFns } from "./PzIdentityDocument.vue?vue&type=template&id=7381e72e&scoped=true&"
import script from "./PzIdentityDocument.vue?vue&type=script&lang=js&"
export * from "./PzIdentityDocument.vue?vue&type=script&lang=js&"
import style0 from "./PzIdentityDocument.vue?vue&type=style&index=0&id=7381e72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7381e72e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7381e72e')) {
      api.createRecord('7381e72e', component.options)
    } else {
      api.reload('7381e72e', component.options)
    }
    module.hot.accept("./PzIdentityDocument.vue?vue&type=template&id=7381e72e&scoped=true&", function () {
      api.rerender('7381e72e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Fields/PzIdentityDocument.vue"
export default component.exports